export default "__VITE_ASSET__DQ92YzzI__"